import * as React from 'react';
import {observer} from 'mobx-react';
import RadioChoose from '../../../../components/Common/Checkboxes/RadioChoose';
import {getLocalizedText, texts} from '../../../../constants/TextConst';

@observer
class ContainerHyperlink extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.renderHyperlinkInput = this.renderHyperlinkInput.bind(this);
    }

    handleRadioChange(value) {
        const {designScreen, handleHideError} = this.props;
        const {selected} = designScreen;
        selected.setIslink(value);

        if (!value) {
            handleHideError();
        }
    }

    renderContainerType() {
        const {designScreen} = this.props;
        const {selected} = designScreen;
        const label = getLocalizedText(texts.typeLabel);

        if (!selected) {
            return null;
        }

        const {islink} = selected;

        const buttons = [
            {
                label: getLocalizedText(texts.textLabel),
                callBack: () => this.handleRadioChange(false)
            },
            {
                label: getLocalizedText(texts.hyperlinkLabel),
                callBack: () => this.handleRadioChange(true)
            }
        ];

        return (
            <section className="radio-selection">
                <label>{label}:</label>
                <RadioChoose selectedDefault={islink ? 1 : 0} elements={buttons} />
            </section>
        );
    }

    renderHyperlinkInput() {
        const {designScreen, saveError, handleHyperlinkValue} = this.props;

        const {selected} = designScreen;

        if (!selected) {
            return null;
        }

        const {islink, hyperlink} = selected;
        const isEmpty = !hyperlink;

        if (!islink) {
            return <div className="link-text-container" />;
        }

        return (
            <div className={`link-text-container visible ${saveError && 'error'}`}>
                <input
                    className={`hyperlink-input ${!isEmpty && 'not-empty'}`}
                    value={hyperlink}
                    type="text"
                    onChange={e => handleHyperlinkValue(e)}
                    placeholder={getLocalizedText(texts.insertHyperlink)}
                />
                {saveError && (
                    <div className="error-label">{getLocalizedText(texts.noLinkError)}</div>
                )}
            </div>
        );
    }

    render() {
        return (
            <div className="containers-hyperlink">
                {this.renderContainerType()}
                {this.renderHyperlinkInput()}
            </div>
        );
    }
}

export default ContainerHyperlink;
